<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button
        (click)="create()"
        [disabled]="inspectionError"
        *ngIf="!paramId"
        >Prüfung anlegen</ion-button
      >
      <ion-button
        (click)="update()"
        [disabled]="inspectionError"
        *ngIf="paramId"
        >Prüfung aktualisieren</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="container">
    <div class="wide">
      <lib-date-time-picker
        [type]="'date'"
        [inputDateZulu]="newInspection.dateUtc"
        (selectedDateChanged)="dateChanged($event)"
      ></lib-date-time-picker>
    </div>

    <br />
    <ion-select
      label="Maschine"
      mode="md"
      label-placement="floating"
      fill="outline"
      (ionChange)="selectedMachineChanged($event.target.value)"
      [value]="newInspection.machineId"
      interface="popover"
    >
      <ion-select-option *ngFor="let value of this.machines" [value]="value.id"
        >{{ value.inventoryNumber }} {{ value.manufacturer }}
        {{ value.type }}</ion-select-option
      >
    </ion-select>
    @if(selectedMachine != null){
    <div style="margin: 5px 0 0 4px">
      Letzte Prüfung:
      {{ tools.formatDt(selectedMachine.lastInspectionUtc) }}
    </div>
    <div style="margin: 0 0 0 4px">
      Betriebsstunden:
      {{ selectedMachine.operatingHours }}
    </div>
    @if(selectedMachine.lastInspectionUtc != null){
    <div class="wide">
      <ion-button (click)="takeLastInspectionAsTemplate()"
        >Letzte Prüfung als Vorlage nutzen</ion-button
      ><ion-button (click)="initNewForm()">Prüfung zurücksetzen</ion-button>
    </div>

    } }

    <ion-textarea
      style="margin: 10px 0"
      label="Betriebsstunden"
      labelPlacement="floating"
      fill="outline"
      mode="md"
      placeholder="Betriebsstunden oder KM-Stand hinzufügen"
      [(ngModel)]="newInspection.operatingHours"
    ></ion-textarea>
    <br />
    <div *ngFor="let group of INSPECTION_GROUPS">
      @if(groupHasElements(group)){
      <div class="group-caption">{{ group.name }}</div>
      <div *ngFor="let element of group.inspectionElements">
        <!--div class="subcaption centered">
          <div>{{ element.name }}:</div>
          <ion-checkbox></ion-checkbox>
          <div>In Ordnung</div>
        </div-->
        @if(newInspection.inspectionResults[element.name] != null){
        <div class="wide">
          <div style="min-width: 250px">
            <div class="subcaption">{{ element.name }}</div>
            <div class="centered" style="margin-top: 5px">
              <ion-checkbox
                [(ngModel)]="
                  newInspection.inspectionResults[element.name].success
                "
              ></ion-checkbox>
              <div style="margin-left: 5px">In Ordnung</div>
            </div>
          </div>

          <ion-textarea
            style="margin: 10px 0"
            label="Beschreibung"
            labelPlacement="floating"
            fill="outline"
            mode="md"
            placeholder="Beschreibung hinzufügen"
            [(ngModel)]="
              newInspection.inspectionResults[element.name].description
            "
          ></ion-textarea>
          <ion-icon
            style="font-size: 52px; margin: 0 5px"
            (click)="removeKey(element.name)"
            name="trash-outline"
          ></ion-icon>
        </div>
        }
        <!--div class="centered">
          <div style="margin-right: 5px">In Ordnung</div>
          <ion-checkbox stlye="margin-right:5px"></ion-checkbox>
          <ion-checkbox stlye="margin-right:5px"></ion-checkbox>
          <div>Nicht in Ordnung</div>
        </div-->

        <!--ion-textarea
          style="margin: 10px 0"
          label="Beschreibung"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          placeholder="Beschreibung hinzufügen.."
        ></ion-textarea-->
      </div>
      }
    </div>

    <ion-textarea
      style="margin: 10px 0"
      label="Bemerkungen"
      labelPlacement="floating"
      fill="outline"
      mode="md"
      placeholder="Bemerkungen hinzufügen"
      [(ngModel)]="newInspection.notes"
    ></ion-textarea>
    <br />
  </div>
</ion-content>
